import { FC, SVGAttributes } from 'react';

const ClosedEye: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.76094 14.3677C9.18594 13.7937 8.83594 13.0137 8.83594 12.1387C8.83594 10.3857 10.2479 8.97266 11.9999 8.97266C12.8669 8.97266 13.6649 9.32366 14.2299 9.89766"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.1034 12.6992C14.8714 13.9892 13.8554 15.0072 12.5664 15.2412"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.655 17.4739C5.068 16.2279 3.724 14.4079 2.75 12.1389C3.734 9.85994 5.087 8.02994 6.684 6.77394C8.271 5.51794 10.102 4.83594 12 4.83594C13.909 4.83594 15.739 5.52794 17.336 6.79294"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.4487 8.99219C20.1367 9.90619 20.7417 10.9612 21.2507 12.1382C19.2837 16.6952 15.8077 19.4402 12.0008 19.4402C11.1378 19.4402 10.2868 19.3002 9.46875 19.0272"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.8873 4.25L4.11328 20.024"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClosedEye;
